import { useEditorStore } from '../../store/editorStore';

export default function ImageProperties({ layer }) {
  const data = layer.data;
  const updateLayerData = useEditorStore((s) => s.updateLayerData);
  const toggleMediaLibrary = useEditorStore((s) => s.toggleMediaLibrary);

  function update(updates) {
    updateLayerData(layer.id, updates);
  }

  return (
    <div className="p-2 space-y-3">
      <p className="panel-label">Image</p>

      <div>
        <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Source URL</label>
        <input
          type="text"
          value={data.src}
          onChange={(e) => update({ src: e.target.value })}
          className="input-field text-xs"
          placeholder="https://..."
        />
        <button onClick={toggleMediaLibrary} className="btn-secondary text-xs mt-1 w-full">
          Choose from Library
        </button>
      </div>

      <div>
        <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Alt Text</label>
        <input
          type="text"
          value={data.alt || ''}
          onChange={(e) => update({ alt: e.target.value })}
          className="input-field text-xs"
          placeholder="Image description"
        />
      </div>

      <div>
        <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Object Fit</label>
        <select
          value={data.objectFit}
          onChange={(e) => update({ objectFit: e.target.value })}
          className="input-field text-xs"
        >
          <option value="cover">Cover</option>
          <option value="contain">Contain</option>
          <option value="fill">Fill</option>
        </select>
      </div>

      <div>
        <label className="text-xs block mb-1" style={{ color: 'var(--t-muted)' }}>Focal Point</label>
        <div className="grid grid-cols-2 gap-1.5">
          <div>
            <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>X (0–1)</label>
            <input
              type="number"
              value={data.focalPoint?.x ?? 0.5}
              onChange={(e) => update({ focalPoint: { x: parseFloat(e.target.value), y: data.focalPoint?.y ?? 0.5 } })}
              step={0.1} min={0} max={1}
              className="input-field text-xs py-1"
            />
          </div>
          <div>
            <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Y (0–1)</label>
            <input
              type="number"
              value={data.focalPoint?.y ?? 0.5}
              onChange={(e) => update({ focalPoint: { x: data.focalPoint?.x ?? 0.5, y: parseFloat(e.target.value) } })}
              step={0.1} min={0} max={1}
              className="input-field text-xs py-1"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
